import React from "react"
import { NativeSelect, InputBase, withStyles } from "@material-ui/core"
import { Error } from '../layout/Error'
import { map } from 'lodash'

export const Dropdown = ({fieldProps, label, options, children, onChange, ...props}) => {
    const { fieldState: { isTouched, error } } = fieldProps
    const { field } = fieldProps

    const localOnChange = (v) => {
        field.onChange(v)
        if ( onChange ) {
            onChange(v)
        }
    }
    
    return (
        <>
          <NativeSelect inputRef={field.ref}
                        onChange={localOnChange}
                        value={field.value}
            
                        style={{
                            background: "white",
                            borderRadius: 5,
                            width: "100%",
                        }}
                        input={<BootstrapInput />}
          >
            {map(options, (item) => (
                <option value={item.value} key={item.value}>
                  {item.label}
                </option>
            ))}
          </NativeSelect>
          
          { error && <Error>{error.message}</Error> }
        </>
    )
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: "white",
        border: "1px solid #ced4da",
        fontSize: 16,
        transition: theme.transitions.create(["border-color", "box-shadow"]),
    },
}))(InputBase)
